import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class BadgesService {
  constructor(private http: HttpClient) {}

  getAllBadges(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/badges`, {
      headers: { lang: langCode },
      params: { searchTerm }
    });
  }

  createBadge(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/badges`, data);
  }

  deleteBadge(id: any): Observable<any> {
    return this.http.delete(`${environment.authUrl}/badges/deleteBadge/${id}`);
  }

  getBadgeById(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/badges/${id}`);
  }

  updateBadge(data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/badges`, data);
  }

  addNewBadgeTraslation(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/badges/addBadgeTranslation`, data);
  }

  deleteBadgeTranslation(id: any): Observable<any> {
    return this.http.delete(`${environment.authUrl}/badges/deleteTranslation/${id}`);
  }

  updateBadgeTranslation(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/badges/updateBadgeTranslation/${id}`, data);
  }
}
